import { ExternalBid } from "Application/features/models/Home/ExternalBid";
import { queryResponse, sibaBackendApi } from "../../backends/sibaApis";

const api = "api/salvageexternal/bid";
/***
 * Service definition for ExternalBid
 *  */
const ExternalBidApi = sibaBackendApi.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Get all endpoint
         *
         */
        queryAllExternalBid: builder.query<ExternalBid[], void>({
            query: () => ({ url: `${api}`, method: "GET" })
        }),
        /**
         * Get by Id endpoint
         * query expects object with parameters Id.
         * Id destructured and passed as a query parameter.
         */
        queryExternalBid: builder.query<queryResponse<ExternalBid>, string>({
            query: (Id: string) => ({ url: `${api}/${Id}`, method: "GET" })
        }),

        /**
         * Save  endpoint
         *
         */
        saveExternalBid: builder.mutation<queryResponse<any>, ExternalBid[]>({
            query: (obj: ExternalBid[]) => ({
                url: `${api}/save`,
                method: "POST",
                //body: obj,
                data: obj
            })
        }),

        /**
         * Update  endpoint
         * query expects object of type country model.
         * Id field is destructure and passed as a query parameter.
         */
        updateExternalBid: builder.mutation<queryResponse<number>, ExternalBid>({
            query: ({ Id, ...rest }: any) => ({
                url: `${api}/update/${Id}`,
                method: "PUT",
                // body: { ${}Id, ...rest },
                data: { Id, ...rest }
            })
        }),
        /**
         * Remove  endpoint
         * query expects object with parameters Id and modified by (string).
         * Id and modifiedby propertied destructured and passed as a query parameter.
         */
        removeExternalBid: builder.mutation<queryResponse<any>, ExternalBid>({
            query: (obj: ExternalBid) => ({
                url: `${api}/delete`,
                method: "POST",
                data: obj
            })
        }),
        /**
         * Sample query method using rtk mutation instead of rtk query.
         */
        getAllExternalBid: builder.mutation<ExternalBid[], void>({
            query: () => ({
                url: `${api}`,
                method: "GET"
            })
        }),
        getExternalBidById: builder.mutation<ExternalBid, string>({
            query: (Id: string) => ({
                url: `${api}/${Id}`,
                method: "GET"
            })
        }),
        /***
         *  Search  Endpoint
         *  using rtk mutations instead of rtk for search.
         * @param query search form object of type ISearchForm.
         */
        searchExternalBid: builder.mutation<queryResponse<ExternalBid[]>, any>({
            query: (query: any) => ({
                url: `${api}/search`,
                method: "POST",
                // body: query,
                data: query
            })
        })
    })
});

export const { useGetAllExternalBidMutation, useQueryAllExternalBidQuery, useRemoveExternalBidMutation, useSaveExternalBidMutation, useGetExternalBidByIdMutation, useUpdateExternalBidMutation } =
    ExternalBidApi;
